// extracted by mini-css-extract-plugin
export default {"content":"ClientDetailSummaryCard_content__Xj7ZD"};